import ActionDropdownItem from './action/ActionDropdownItem';
import CheckableDropdownItem from './checkable/CheckableDropdownItem';
import ListDropdownItem from './list/ListDropdownItem';

export {
  ActionDropdownItem,
  CheckableDropdownItem,
  ListDropdownItem,
};

type StyleClassNames = { [key: string]: string };
type Name = string | number | undefined;

export interface BaseDropdownItemProps {
  name: Name;
  styleClassNames: StyleClassNames;
  variantName: string;
  icon?: string;
  iconSize?: number;
  isArrowed?: boolean;
  isDisabled?: boolean;
  isDisplayed?: boolean;
  isSelected?: boolean;
  isTabbable?: boolean;
  isWarningItem?: boolean;
  onChoose?: (name: Name, e?: React.SyntheticEvent) => void;
}

export type ActionDropdownItemProps = Omit<BaseDropdownItemProps, 'styleClassNames' | 'variantName' | 'isArrowed' | 'isDisabled' | 'isSelected'>;
export type ListDropdownItemProps = Omit<BaseDropdownItemProps, 'styleClassNames' | 'variantName' | 'icon' | 'iconSize' | 'isWarningItem'>;
export type CheckableDropdownItemProps = Omit<BaseDropdownItemProps, 'styleClassNames' | 'variantName' | 'icon' | 'iconSize' | 'isDisplayed' | 'isWarningItem'>;
